import { render, staticRenderFns } from "./AffiliateInvoicesWrap.vue?vue&type=template&id=503661e6&"
import script from "./AffiliateInvoicesWrap.vue?vue&type=script&lang=ts&"
export * from "./AffiliateInvoicesWrap.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateInvoicesWrap.vue?vue&type=style&index=0&id=503661e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports